export function syncState(state, defaultValue = null, errorValue = syncState.UNSET) {
  return state?.isResolved ? state.value
    : state?.isRejected && errorValue !== syncState.UNSET ? errorValue
    : defaultValue;
}
syncState.UNSET = Symbol();
